if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }


const KEYS = {LEFT: 37, RIGHT: 39};
const BODY_OFFSET_ID = 'l2h-modal-scroll-fix';

let originalBodyOffsetY = null;

const setBodyOffset = function(offset) {
  const $div = `<div id='${BODY_OFFSET_ID}'><style>body {top: ${offset}px;}</style></div>`;

  if ($(`#${BODY_OFFSET_ID}`).length === 0) {
    $($div).appendTo('body');
  }
};

const removeBodyOffset = () => $(`#${BODY_OFFSET_ID}`).remove();


L2H.PhotoModalView = class PhotoModalView {
  constructor($container, widgetType, fetchPhotos, options) {
    this.nextPhoto = this.nextPhoto.bind(this);
    this.previousPhoto = this.previousPhoto.bind(this);
    this.keyPressed = this.keyPressed.bind(this);
    this.photoClicked = this.photoClicked.bind(this);
    this.$container = $container;
    this.widgetType = widgetType;
    this.fetchPhotos = fetchPhotos;
    if (options == null) { options = {}; }
    this.options = options;
    this.photos = [];
    this.selectedPhotoIndex = null;
    this.trackers = [];

    this.trackers.push(new L2H.Tracker(L2H.clientTrackerID, `${L2H.permalink}|${this.widgetType}`, L2H.rootURL));
    this.trackers.push(new L2H.InternalTracker(L2H.permalink, this.widgetType, L2H.appURL));

    if (this.options.lt != null) {
      this.openShopableLinksInNewWindow = !(this.options.lt === 'c');
    } else {
      this.openShopableLinksInNewWindow = true;
    }

    this.photoModal = new L2H.PhotoModalBodyView(this.$container, {openShopableLinksInNewWindow: this.openShopableLinksInNewWindow});

    this.bindEvents();
  }

  setPhotos(newPhotos) {
    return this.photos = newPhotos;
  }

  setPhoto(photo) {
    if (photo != null) {
      this.selectedPhotoIndex = $.inArray(photo, this.photos);
    }

    if (photo != null) {
      this.photoModal.setPhoto(photo);
      for (const tracker of this.trackers) {
        tracker.trackModalView(photo.id)
      }
    }

    if (this.selectedPhotoIndex === (this.photos.length - 1)) {
      this.disableNextBtn();
      if (this.fetchPhotos) {
        const deferred = this.fetchPhotos();
        self = this;
        deferred.done(function(data) {
          if (self.selectedPhotoIndex === (self.photos.length - 1)) {
            self.disableNextBtn();
          } else {
            self.enableNextBtn();
          }
        });
      }
    } else {
      this.enableNextBtn();
    }


    if (this.selectedPhotoIndex === 0) {
      this.disablePrevBtn();
    } else {
      this.enablePrevBtn();
    }
  }

  disablePrevBtn() {
    this.$container.find('.l2h-previous').addClass('l2h-disabled');
  }

  enablePrevBtn() {
    this.$container.find('.l2h-previous').removeClass('l2h-disabled');
  }

  disableNextBtn() {
    this.$container.find('.l2h-next').addClass('l2h-disabled');
  }

  enableNextBtn() {
    this.$container.find('.l2h-next').removeClass('l2h-disabled');
  }

  nextPhoto() {
    const photo = this.photos[this.selectedPhotoIndex + 1];
    if (photo != null) {
      this.setPhoto(photo);
    }
  }

  previousPhoto() {
    if (this.selectedPhotoIndex > 0) {
      const photo = this.photos[this.selectedPhotoIndex - 1];
      this.setPhoto(photo);
    }
  }

  gotoURL(url, photo, shopableID) {
    let promises = [];
    if (photo != null) {
      for (const tracker of this.trackers) {
        promises.push(tracker.trackShopableClick(url, photo.id, shopableID));
      }
    }

    if (this.openShopableLinksInNewWindow) {
      if (L2H.debug) { console.log(`L2H DEBUG: about to open shoppable link ${url} in new window`); }
      return window.open(url,'_blank');
    } else {
      if (L2H.debug) { console.log(`L2H DEBUG: about to open shoppable link ${url} in current window`); }
      return $.when.apply($, promises).done(function() {
        if (L2H.debug) { console.log("L2H DEBUG: tracking completed"); }
        return document.location = url;
      });
    }
  }

  // there's only one modal and it gets placed in the first widget. So it cannot be scoped to the container
  bindEvents() {
    const self = this;
    this.$container
      .on('click', '.l2h-force-default-click', function(e) {
        e.stopPropagation();
      })
      .on('click', '.l2h-photowrap:not(.l2h-force-default-click)', this.photoClicked)
      .on('click', '.l2h-next', function(e) {
        e.preventDefault();
        return self.nextPhoto();
      }).on('click', '.l2h-previous', function(e) {
        e.preventDefault();
        return self.previousPhoto();
      }).on('shown.bs.modal', () => self.enableModalScrolling())
      .on('hidden.bs.modal', () => self.disableModalScrolling())
      .on('click', '.trackable-link', function(e) {
        e.preventDefault();
        const $link = $(this);
        const shopableID = $link.data('shopable-id');
        if (L2H.debug) { console.log(`L2H DEBUG: you clicked on shopable with id: ${shopableID}`); }
        const url = $link.attr('href');
        const photo = self.photos[self.selectedPhotoIndex];

        return self.gotoURL(url, photo, shopableID);
      });

    $(document)
      .unbind('keydown.l2h', this.keyPressed)
      .bind('keydown.l2h', this.keyPressed);

    // this syntax allows us to simulate swipes using
    // trigger('swipe', 'left')
    this.$container.find('[data-l2h-photo-modal-body]')
      .swipe({
        swipeLeft(e) {},
        swipeRight(e) {},
        excludedElements:'label, button, input, select, textarea, .noSwipe'}).on('swipe', function(e, direction) {
          switch (direction) {
          case "left":
            self.nextPhoto();
            break;
          case "right":
            self.previousPhoto();
            break;
          }
        });
  }

  // allows modal to be scrolled when the height of the modal
  // is taller than the height of the window.
  // not exactly sure why the default behaviour is broken to begin with
  enableModalScrolling() {
    if (L2H.features.modalScrollFix) {
      const $document = $(document);
      // see https://github.com/twbs/bootstrap/issues/17695
      // and https://bugs.webkit.org/show_bug.cgi?id=150715
      if (L2H.debug) { console.log("L2H DEBUG: applying modalScrollFix"); }
      originalBodyOffsetY = $document.scrollTop();
      $('html').addClass('l2h-modal-scrollfix');
      setBodyOffset(-originalBodyOffsetY);
    }
  }

  disableModalScrolling() {
    if (L2H.features.modalScrollFix) {
      removeBodyOffset();
      $('html').removeClass('l2h-modal-scrollfix');
      $(document).scrollTop(originalBodyOffsetY);
    }
  }

  keyPressed(e) {
    if (!this.photoModal.isModalShowing()) { return; }

    e.preventDefault();
    switch (e.which) {
    case KEYS.RIGHT:
      this.nextPhoto();
      break;
    case KEYS.LEFT:
      this.previousPhoto();
      break;
    }
  }

  photoClicked(e) {
    let photo;
    e.preventDefault();
    const id = $(e.currentTarget).data('id');

    if (L2H.debug) { console.log(`L2H DEBUG: you clicked on photo with id: ${id}`); }

    for (let i = 0; i < this.photos.length; i++) {
      if (this.photos[i].id === id) {
        photo = this.photos[i];
      }
    }

    if (L2H.preferences.modalDisabled) {
      const shopable = photo.shopables[0];

      if (L2H.debug) { console.log(`L2H DEBUG: you clicked on shopable with id: ${shopable.id}`); }
      if (shopable) {
        this.gotoURL(shopable.url, photo, shopable.id);
      }
    } else {
      this.setPhoto(photo);
      this.photoModal.show();
    }
  }
};
